import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCallIncoming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCallIncoming"><Path d="M3 3.00015V4.00015C3 13.389 10.6112 21.0002 20 21.0002H21V14.4561L15.7152 12.8707L14.1216 14.4644C12.2053 13.3854 10.6148 11.7948 9.5358 9.87857L11.1295 8.28491L9.54403 3.00015H3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M19.9998 10.0002H13.9998V4.00015H15.9998V6.58594L19.9998 2.58594L21.4141 4.00015L17.4141 8.00015H19.9998V10.0002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCallIncoming;
